<template>
  <div style="width: 100%;height: 100%;" class="overflow-auto  pb-16px" v-show="elementListShow == false">
    <div class="header flex items-center gap-8px mb-12px cursor-pointer" @click="handleBack">
      <el-icon class=" back-icon cursor-pointer">
        <ArrowLeft />
      </el-icon>
      <div class="title">合集</div>
    </div>
    <CollectList :showNum="0" @selectMore="handleMoreClick">
    </CollectList>
  </div>
  <div class="element-list" v-if="elementListShow">
    <elementlist :categoriesShow="false" :category="categoryopt" @back="elementListShow = false" type="collect">
    </elementlist>
  </div>
</template>

<script lang="ts" setup>
import { onMounted, ref } from 'vue'
import { ElInput, ElButton, ElCascader, ElIcon } from 'element-plus'
import { ArrowDown, Search, ArrowLeft } from '@element-plus/icons-vue'
import { } from '@/api/affairs'
// @ts-ignore
import elementItem from './elementItem.vue'
// @ts-ignore
import elementlist from './elementlist.vue'
// @ts-ignore
import CollectList from './collectList.vue'

const elementListShow = ref(false)
const searchShow = ref(true)
const emit = defineEmits<{
  back: []
}>()
const handleBack = () => {
  emit('back')
}
const categoryopt = ref({})

onMounted(() => {

})


const handleMoreClick = (item) => {
  elementListShow.value = true
  console.log('item', item)
  categoryopt.value = item
}
const getimage = (val) => {

}
</script>
<style lang="scss"></style>
